import { Prose, type ProseProps } from '@leanin/ui/server';
import { remarkLinkifyUrls } from './remark-linkify-urls';
import { ContentAnchor } from '@/components/external-link';

// The in-app renderer for authored / markdown content. Identical to the
// `@leanin/ui` `Prose` primitive, except every link routes through
// `ContentAnchor` → `ExternalLink`: internal Connect links (relative,
// same-origin, or a connect.leanin.org host) navigate in the SAME tab via the
// client router, and external links open a new tab behind the confirm
// interstitial. Bare-domain URLs in plain text (`leanin.org/foo`) are also
// linkified (remarkLinkifyUrls) — GFM autolink literals only catch schemed and
// `www.`-prefixed URLs, and content here (coach replies especially) is not
// guaranteed to arrive with URLs pre-wrapped as markdown links.
//
// Bare `Prose` lives in `packages/ui` and is host-agnostic — it force-opens
// every absolute link in a new tab (rehype-external-links) and never does SPA
// navigation, which is wrong for in-app content that links to other Connect
// destinations. The Connect origin and the app router live in `apps/web`, so
// the smart-link behaviour cannot move into the primitive; this compound wires
// it in at the app layer instead.
//
// Use this for any authored markdown rendered in the web app. Post and comment
// bodies use `RichBodyRenderer`, which layers @mention member links on top of
// the same `ContentAnchor`.
export function ContentProse(props: ProseProps) {
  // A caller-supplied `a` override still wins (spread after the default); none
  // do today.
  return (
    <Prose
      {...props}
      remarkPlugins={[remarkLinkifyUrls, ...(props.remarkPlugins ?? [])]}
      components={{ a: ContentAnchor, ...props.components }}
    />
  );
}
